module.exports = __webpack_public_path__ + "img/icon_home_app@2x.80eb77e0.png";